import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditStaffLayer from "../components/EditStaffLayer";

const EditStaffListPage = () => {
  return (
    <>
      <Breadcrumb title="Edit Staff" />
      <EditStaffLayer />
    </>
  );
};

export default EditStaffListPage;
